import script from "./LogoutSession.vue?vue&type=script&lang=js"
export * from "./LogoutSession.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__